export default function keyBy(array, keyName, callback = () => {}) {
    return array.reduce((acc, item) => {
        callback(item);

        acc[item[keyName]] = item;

        return acc;
    }, {});
}
